window.anvil.component('listing-dropdown', el => {
	const dropdown = el.querySelector( '.js-toggler' );

	if (dropdown) {
		dropdown.addEventListener( 'click', () => dropdown.focus() );
	}
});